module.exports = __webpack_public_path__ + "img/retail-3.dc702e69.png";